/**
 * Added `imageRef` prop.
 */

import { useImagePath } from '@/data/Content/_ImagePath';
import { CardMedia, CardMediaTypeMap } from '@mui/material';
import { OverridableComponent } from '@mui/material/OverridableComponent';
import { ComponentProps, Ref } from 'react';

type Props = ComponentProps<
	OverridableComponent<CardMediaTypeMap<Record<string, unknown>, 'div'>>
> & {
	imageRef?: Ref<HTMLImageElement>;
};
export const MuiCardMedia = (props: Props) => {
	const { image: img, imageRef, ...rest } = props;
	const image = useImagePath(img ?? '');
	return <CardMedia {...rest} image={image} ref={imageRef as any} />;
};
